/*
 * Replace the element 'Other' with 'Other: otherValue'
 * Input:
 *   choices - array of strings
 *   otherValue - string to insert into array
 *   phrase - string to search for and replace
 * Return a new array or string.
 */
export const replacePhraseWithString = (
  choices,
  otherValue,
  phrase = 'Other'
) => {
  let result = choices
  const newPhrase = phrase + ': ' + otherValue
  if (Array.isArray(choices)) {
    result = choices.map(item => (item === phrase ? newPhrase : item))
  } else if (typeof choices === 'string' || choices instanceof String) {
    result = choices.replace(phrase, newPhrase)
  }
  return result
}
